module.exports = __webpack_public_path__ + "img/alya_8046_detail.34175964.jpg";